<template>
  <div class="content">
    <DialogBase panel-title="Thông tin chung" panel-subtitle="Vui lòng điền đầy đủ thông tin" panel-icon="el-icon-document-add" 
        :visible.sync="dialogVisibleFile"
        size="lg"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        top="80px"
        title="THÊM THỰC ĐƠN DẠNG FILE, ẢNH"
    >
      <div style="display: flex; justify-content: space-between">
        <el-upload
            ref="upload"
            class="upload-demo"
            action
            :on-remove="handleRemove"
            :before-remove="beforeRemove"
            multiple
            :auto-upload="false"
            :on-change="importFile"
            :limit="5"
            :on-exceed="handleExceed"
            :on-preview="handleFileRequest"
        >
          <el-button @change="importFile()" size="mini" type="primary"
          >Nhập file
          </el-button
          >
        </el-upload>
      </div>

      <div style="margin-top: 50px">
        <el-row type="flex" :gutter="20">
          <el-col :span="12">
            <div class="button-click-left">
              <el-row type="flex" :gutter="10">
                <el-col :span="6">
                  <el-date-picker
                      style="width: 100%"
                      v-model="createTimeClassMenu"
                      type="week"
                      value-format="yyyy-MM-dd"
                      format="Tuần WW"
                      placeholder="Chọn tuần"
                      :clearable="false"
                      @change="getValueDateClassMenu(createTimeClassMenu)"
                  ></el-date-picker>
                </el-col>

                <el-col :span="18">
                  <el-select
                      style="width: 100%"
                      v-model="listCreateTimeClassMenu"
                      multiple
                      @change="changeWeek()"
                      placeholder="Tuần đã chọn"
                  ></el-select>
                </el-col>
              </el-row>
            </div>
          </el-col>

          <el-col :span="12">
            <div>
              <el-select
                  v-model="createMultiClassMenu.listIdClass"
                  class="button-left"
                  placeholder="Chọn lớp"
                  :clearable="true"
                  style=" width: 100%"
                  :multiple="true"
              >
                <el-option
                    v-for="item in classListCommon"
                    :key="item.id"
                    :label="item.className"
                    :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </el-col>
        </el-row>

        </div>


        <template #footer>
        <div style="margin-top: 10px; display: flex; justify-content: flex-end;">
          <el-button @click="closeDialog" plain class="btn-cancel">
            Đóng
          </el-button>
          <el-button
              @click="handleChange()"
              type="primary"
              class="btn-save"
              v-loading.fullscreen.lock="fullscreenLoading"
          >
            Tải lên
          </el-button>
        </div>
        </template>
    </DialogBase>
  </div>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import ClassMenuService from "../../services/ClassMenuService";

import moment from "moment";
import {mapGetters} from "vuex";

export default {
  components: { DialogBase },
  props: {
    dialogVisibleFile: null,
  },
  data() {
    return {
      url: "https://media.onekids.edu.vn/sysfiles/other/MAU_THUC_DON_TUAN_50.xlsx",
      fullscreenLoading: false,
      createTimeClassMenu: "",
      listTimeClassMenu: "",
      listCreateTimeClassMenu: [],
      file: "",
      fileList: [],

      IndexRow: 0,
      tabListClassMenuDetail: [],
      createMultiClassMenu: {
        weekClassMenu: [],
        listIdClass: "",
      },
    };
  },
  computed: {
    ...mapGetters('classStore', ['classListCommon'])
  },
  created() {
    this.$store.dispatch('classStore/fetchDataClassListCommon')
  },
  methods: {
    openFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: "Dữ liệu đang xử lý. Xin vui lòng chờ trong giây lát!",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // setTimeout(() => {
      //   loading.close();
      // }, 2000);
    },
    // dowloadFile() {
    //   const url = this.url;
    //   const link = document.createElement("a");
    //   link.href = url;
    //   link.setAttribute("download", "MAU_THUC_DON_TUAN_50.xlsx"); //or any other extension
    //   document.body.appendChild(link);
    //   link.click();
    // },
    closeDialog() {
      //   this.$refs["createMultiSchedule"].resetFields();
      this.$refs.upload.clearFiles();
      this.file = "";
      this.fileList = [];
      (this.createTimeClassMenu = ""), (this.listCreateTimeClassMenu = []);
      this.createMultiClassMenu.weekClassMenu = [];
      this.createMultiClassMenu.listIdClass = "";
      this.$emit("dialog-close");
      //   this.resetData();
    },
    importFile(file, fileList) {
      this.fileList = fileList;
    },
    handleChange() {
      const formData = new FormData();
      const idClass = this.createMultiClassMenu.listIdClass;
      const timeClassMenu = this.createMultiClassMenu.weekClassMenu;

      this.fileList.forEach((element) => {
        formData.append("multipartFile", element.raw);
      });
      formData.append("weekClassMenu", timeClassMenu);
      formData.append("listIdClass", idClass);

      if (
          this.createMultiClassMenu.listIdClass.length > 0 &&
          this.createMultiClassMenu.weekClassMenu.length > 0
      ) {
        if (this.fileList.length) {
          this.$confirm("Dữ liệu cũ sẽ được xóa và thay bằng dữ liệu mới.", {
            distinguishCancelAndClose: true,
            closeOnClickModal: false,
            confirmButtonText: "Có",
            cancelButtonText: "Không",
          }).then(() => {
            this.openFullScreen();
            ClassMenuService.createFileMultiClassMenu(formData)
                .then((resp) => {
                  this.loading.close();
                  this.$message({
                    message: resp.data.message,
                    type: "success",
                  });
                  setTimeout(() => {
                    this.closeDialogByButton();
                  }, 500);
                })
                .catch((err) => {
                  this.loading.close();
                  this.$message({
                    message: err.response.data.message,
                    type: "error",
                  });
                });
          });
        } else {
          this.$message({
            message: "Bạn phải chọn file",
            type: "error",
          });
        }
      } else {
        this.$message({
          message: "Bạn phải chọn lớp và tuần áp dụng",
          type: "error",
        });
      }
    },
    handleExceed() {
      this.$message.warning(`Chỉ được chọn 5 File`);
    },
    getValueDateClassMenu(createTimeClassMenu) {
      // Xử lý ngày trả về từ el-date-picker
      const selectedDate = moment(createTimeClassMenu, "YYYY-MM-DD");

      // Lấy ngày đầu tuần (Thứ Hai) và cuối tuần (Chủ Nhật)
      const startOfWeek = selectedDate.startOf("isoWeek").format("DD-MM-YYYY");
      this.createTimeClassMenu = createTimeClassMenu;
      let a = selectedDate.startOf("isoWeek").format("YYYY-MM-DD");

      let weeknumber = moment(a, "YYYY-MM-DD").isoWeek();

      let formatweek =
          "Tuần " + weeknumber + "(từ " + startOfWeek + ")";
      let indexOfFormatWeek = this.listCreateTimeClassMenu.indexOf(formatweek);
      if (indexOfFormatWeek == -1) {
        this.listCreateTimeClassMenu.push(formatweek);
      } else {
        this.listCreateTimeClassMenu.splice(indexOfFormatWeek, 0);
      }
      let indexOfCreateTimeClassMenu =
          this.createMultiClassMenu.weekClassMenu.indexOf(a);
      if (indexOfCreateTimeClassMenu == -1) {
        this.createMultiClassMenu.weekClassMenu.push(a);
      } else {
        this.createMultiClassMenu.weekClassMenu.splice(
            indexOfCreateTimeClassMenu,
            0
        );
      }
    },
    changeWeek() {
      let c = this.listCreateTimeClassMenu;
      this.createMultiClassMenu.weekClassMenu = [];
      c.forEach((element) => {
        {
          let date = element.slice(-11, -1);
          const newdate = date.split("-").reverse().join("-");
          this.createMultiClassMenu.weekClassMenu.push(newdate);
        }
      });
    },

    closeDialogByButton() {
      this.$refs.upload.clearFiles();
      this.file = "";
      this.fileList = [];
      (this.createTimeClassMenu = ""), (this.listCreateTimeClassMenu = []);
      this.createMultiClassMenu.weekClassMenu = [];
      this.createMultiClassMenu.listIdClass = "";
      this.$emit("dialog-close");

    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/sk-dialog.scss";
</style>
